<template>
	<div class="work-order-log">
		<div @click="addVisible = true" v-bind:class="{ addRemarkShow: isTrue }">
			<el-button class="addBtn">添加备注</el-button>
		</div>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="日志" name="second">
				<el-card class="box-card" v-for="(item, index) in logLists" :key="index">
					<div class="iconfont icon-zhushi"></div>
					<div class="content-box">
						<ul>
							<!-- <li>{{item.creater}}</li> -->
							<li>{{ item.createTimeStr }}</li>
							<li>{{ item.createrName }}</li>
						</ul>
						<div class="inform">
							<div v-if="item.statusMsg">{{ item.statusMsg }}</div>
							<div v-if="item.remarks" class="inform_remarks">备注：{{ item.remarks }}</div>
						</div>
					</div>
				</el-card>
				<section v-bind:class="{ noData: loghasData, dataBox: lognot }">暂无数据</section>
			</el-tab-pane>
		</el-tabs>

		<el-dialog title="添加备注" :visible.sync="addVisible" width="30%">
			<el-form ref="form" :rules="rules" :model="form">
				<el-form-item prop="remarks">
					<el-input type="textarea" v-model="form.remarks"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel">取 消</el-button>
				<el-button type="primary" @click="addRemarks('form')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import ajax from '@/backend/services/workOrder/orderLog.js';
import { validRequired } from '@/common/elementValid.js';
export default {
	name: 'work-order-log',
	props: ['id'],
	data() {
		return {
			isTrue: true,
			isShow: false,
			hasData: false,
			loghasData: false,
			lognot: true,
			not: true,
			activeName: 'second',
			remarkList: [],
			logLists: '',
			addVisible: false,
			workOrderId: '',
			form: {
				remarks: '',
				workOrderId: this.id,
			},
			rules: {
				remarks: [validRequired()],
			},
		};
	},
	watch: {
		isTrue() {
			this.isTrue == true ? (this.isShow = false) : (this.isShow = true);
		},
	},
	methods: {
		cancel() {
			this.addVisible = false;
			this.form.remarks = '';
		},
		handleClick(tab) {
			if (tab.name == 'second') {
				this.getWorkOrderlog();
				this.isTrue = false;
				this.isShow = true;
			} else if (tab.name == 'first') {
				this.isShow = false;
				this.isTrue = true;
			}
		},

		// 新增备注
		async addRemarks(form) {
			this.$refs[form].validate(valid => {
				if (!valid) {
					this.$message({
						message: '请输入备注',
						type: 'warning',
					});
					return false;
				}
				this.addVisible = false;
				ajax.addRemarks(this.form).then(datas => {
					if (datas.status == 201 || datas.status == 200) {
						this.$message.success('添加备注成功');
						this.addVisible = false;
						this.form.remarks = '';
						this.getWorkOrderlog();
					}
				});
			});
		},

		// 获取日志列表
		async getWorkOrderlog() {
			let datas = await ajax.workorderlog({ id: this.id });
			this.logLists = datas.data;
			if (this.logLists.length > 0) {
				this.loghasData = false;
				this.lognot = true;
			} else {
				this.loghasData = true;
				this.lognot = false;
			}
		},
	},
	mounted() {
		this.getWorkOrderlog();
	},
};
</script>

<style scoped lang="scss">
.work-order-log {
	// width:1028px;
	position: relative;
	padding: 11px;
	background: #fff;

	.box-card {
		padding-top: 6px;
		padding-left: 12px;
		padding-bottom: 15px;
		margin-bottom: 10px;
		box-shadow: none;
		border-top: 1px solid #e3e5ec;
		border-bottom: 1px solid #e3e5ec;

		ul {
			width: 100%;

			li {
				float: left;
			}

			li:nth-child(1) {
				font-size: 14px;
			}

			li:nth-child(2) {
				margin-left: 10px;
				color: #999;
				font-size: 6px;
			}

			li:nth-child(3) {
				float: right;
			}
		}

		.inform {
			clear: both;
			color: #333;
			font-size: 14px;
			margin-top: 25px;

      .inform_remarks {
        white-space: pre-line;
      }
		}
	}

	.addRemarkShow {
		margin-left: 89%;
		position: absolute;
		top: 5px;
		z-index: 100;
	}

	.isActive {
		display: none;
	}

	.noData {
		display: block;
		width: 100%;
		height: 100px;
		text-align: center;
		line-height: 100px;
	}

	.dataBox {
		display: none;
	}

	.handle {
		cursor: pointer;
	}

	.handle:hover {
		color: #54a8fe;
	}
}

.icon-beizhu1 {
	float: left;
	font-size: 30px;
	margin-right: 20px;
	color: #54a8fe;
}

.content-box {
	width: 91%;
	float: left;
}

.icon-shanchu {
	font-size: 14px;
}
</style>
